module.exports = __webpack_public_path__ + "img/card-icon-calendar.d1aeb4d1.svg";